import {Component, OnInit, ElementRef, ViewChild, OnDestroy, AfterViewInit} from '@angular/core';
import {
  ProjectActivityService
} from 'projects/app-misc/src/app/modules/project-misc/data/project/activity/project-activity.service';
import {upperCaseValue, getValue} from 'projects/core/src/public-api';
import * as moment from 'moment';
import {Customer} from 'projects/app-misc/src/app/modules/customer/data/customer';
import {CustomerService} from 'projects/app-misc/src/app/modules/customer/data/customer.service';
import {
  CustomerWindowComponent
} from 'projects/app-misc/src/app/modules/customer/view/customer-window/customer-window.component';
import {LocalStorage} from 'ngx-webstorage';
import {Table} from 'primeng/table';
import {MatDialog} from '@angular/material/dialog';
import {timer, Subject} from 'rxjs';
import {QbCustomerLinkDialogComponent} from './qb-customer-link-dialog/qb-customer-link-dialog.component';
import {debounceTime} from 'rxjs/operators';
import {CustomerResponcePage} from 'projects/app-misc/src/app/modules/customer/data/customer-responce-page';
import {Router} from '@angular/router';


class TableColumnDef {
  field: string
  header: string
  type?: 'Date' | 'number' | 'customer'
  renderer?: any
}

@Component({
  selector: 'app-customers-list',
  templateUrl: './customers-list.component.html',
  styleUrls: ['./customers-list.component.scss']
})
export class CustomersListComponent implements OnInit, OnDestroy, AfterViewInit {
  customers: Customer[];

  cols: TableColumnDef[];

  loadingProjects = true;

  // TODO move to env
  projectsPerPage = 15;
  totalElements: number;

  colsForSearch = [];

  @ViewChild('dt', {static: true})
  customersTable: Table;

  @LocalStorage()
  showActiveCustomers: boolean;

  first: number;
  rows: number;

  searchString = '';

  loadSubj = new Subject<void>();

  footerString: string;

  constructor(
    public router: Router,
    protected el: ElementRef,
    protected dialog: MatDialog,
    protected customerService: CustomerService,
    protected projectActivityService: ProjectActivityService
  ) {
    this.cols = [
      {field: 'name', header: 'Name', renderer: upperCaseValue},
      {field: 'billingInfoContact.phone1', header: 'Phone #1'},
      {field: 'billingInfoContact.email', header: 'E-Mail'},
      {field: 'billingInfoContact.fax', header: 'Fax'},
      {field: 'billingInfoContact.qbId', header: 'QB Link'}
    ];
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    timer(1).subscribe(emit => {
      this.projectsPerPage = Math.max(this.projectsPerPage, Math.trunc((this.el.nativeElement.offsetHeight - 150) / 35));
      this.loadNewProjects(0, this.projectsPerPage, !this.showActiveCustomers);

      this.countCols();
      this.subToLoadMaterials();
    })
  }

  subToLoadMaterials() {
    this.loadSubj.pipe(debounceTime(500)).subscribe(emit => {
      this.customersTable.reset()
    })
  }

  topSearchBar() {
    this.loadSubj.next()
  }

  countCols() {
    this.cols.forEach(col => {
      this.colsForSearch.push(col.field)
    })
  }

  openClient(event: any) {
    this.openClientWindow(event.data)
  }

  loadProjectsLazy(event: any) {
    this.loadNewProjects(event.first, event.rows, !this.showActiveCustomers);
  }

  loadNewProjects(start: number, limit: number, active?: boolean) {
    this.first = start;
    this.rows = limit;

    this.loadingProjects = true

    if (this.searchString.length === 0) {
      if (active) {
        this.customerService
          .getCustomers(start / limit, limit, active)
          .subscribe(page => {
            this.fillCustomers(page)
          })
      } else {
        this.customerService
          .getCustomers(start / limit, limit)
          .subscribe(page => {
            this.fillCustomers(page)
          })
      }

    } else {
      this.customerService
        .searchCustomers(this.searchString, start / limit, limit)
        .subscribe(page => {
          this.fillCustomers(page)
        })
    }
  }

  fillCustomers(page: CustomerResponcePage) {
    this.customers = page.content
    this.totalElements = page.totalElements

    this.countFooter();

    this.loadingProjects = false
  }

  countFooter() {
    let max = this.projectsPerPage * (this.first / this.rows + 1);
    max = max < this.totalElements ? max : this.totalElements;

    this.footerString = `${this.first + 1} to ${max} of ${this.totalElements}`;
    // if()
  }

  openClientWindow(data: Customer) {
    const dialogRef = this.dialog.open(CustomerWindowComponent, {
      data: {
        id: data.id
      },
      panelClass: 'customer-window-dialog'
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loadNewProjects(this.first, this.rows, !this.showActiveCustomers);
    });
  }

  getFieldData(rowData: any, col: TableColumnDef) {
    let value = getValue(rowData, col.field)
    if (col.type === 'Date') {
      value = moment(value).format('ll');
    } else if (col.type === 'number') {
      value = Math.round(value * 100) / 100
    }

    if (col.renderer) {
      value = col.renderer(value)
    }

    if (col.field === 'billingInfoContact.qbId') {
      return (rowData as Customer);
    }
    // if col has renderer, then apply this renderer to value

    return value
  }

  toggleCustomers(event: boolean) {
    this.customersTable.reset();
  }

  onSearch() {
    // if (this.searchString !== '') {
    // 	this.showCloseIcon = true;
    // }
    // else if (this.searchString === '') {
    // 	this.showCloseIcon = false;
    // }

    // if (!this.barSubj) {
    // 	this.barSubj = timer(700).pipe(
    // 		distinctUntilChanged(),
    // 		takeUntil(this.getUnsubFromAllSubs())
    // 	).subscribe(emit => {
    // 		this.customersTable.reset();
    // 		this.barSubj = null;
    // 	})
    // }

    this.customers = [this.customers[0]]
  }

  clearSearchInput() {
    this.searchString = '';
    this.customersTable.reset();
  }

  qbLink(event, rowData: Customer, col: TableColumnDef) {
    event.stopPropagation();


    const dialogRef = this.dialog.open(QbCustomerLinkDialogComponent, {
      data: {
        customerName: rowData.name,
        customerId: rowData.id,
        qbId: rowData.qbId ? rowData.qbId : null
      },
      panelClass: 'qb-link-dialog',
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (typeof result !== 'undefined') {
        if (result !== 'close-button') {
          const fcust = this.customers.find(ccust => ccust.id === result.id);
          if (fcust) {
            fcust.qbId = result.qbId
            fcust.qbDisplayName = result.qbDisplayName
          }
        }
      }
    });
  }


  ngOnDestroy() {

  }
}
